import React from "react";
import {useGetTournaments} from "../hooks/tournamentHooks";
import {useNavigate} from "react-router-dom";
import type {Tournament} from '@iziping/common';
import {useTranslation} from "react-i18next";
import { useTournamentStore } from '../../../service/useTournamentStore';
import {format} from "date-fns";
import { useNotification } from '@iziping/ui';


const TournamentListPage: React.FC = () => {

        const {t} = useTranslation();

        const {data: tournaments, error} = useGetTournaments();
        const {selectTournament} = useTournamentStore();

        const navigate = useNavigate();
        const handleItemClick = (tournamentId: number) => {
            const tournament = tournaments?.find(t => t.id === tournamentId);
            if (tournament) {
                selectTournament(tournament);
            }

            navigate(`/tournaments/${tournamentId}`);
        };

        const {notify} = useNotification();

        if (error) {
            notify(t(error.error), 'error');
            return null;
        }

        return (
            <div className={'page'}>
                <h3>{t('TOURNAMENTS_TITLE')}</h3>
                <table className={'table-stripped'}>
                    <thead>
                        <tr>
                            <th>{t('TOURNAMENTS_NAME')}</th>
                            <th>{t('TOURNAMENTS_LOCATION')}</th>
                            <th>{t('TOURNAMENTS_DATE')}</th>
                            <th>{t('TOURNAMENTS_TABLES')}</th>
                            <th>{t('TOURNAMENTS_MAX_HEATS')}</th>
                        </tr>
                    </thead>
                    <tbody>
                    {tournaments?.map((tournament: Tournament) => (
                        <tr key={tournament.id} onClick={() => handleItemClick(tournament.id)}>
                            <td>{tournament.name}</td>
                            <td>{tournament.location}</td>
                            <td>{format(tournament.date, 'dd/MM/yyyy')}</td>
                            <td>{tournament.nbTables}</td>
                            <td>{tournament.maxHeat || '-'}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        );
    }
;

export default TournamentListPage;